import type { BoggleBadgeCheck } from '../checkTypes'
import { explorerCompletionIndex } from '../checkLedger'

const EXPLORER_STREAK_REQUIRED = 10

export const explorerCheck: BoggleBadgeCheck = (ledger, index) =>
  explorerCompletionIndex(ledger, EXPLORER_STREAK_REQUIRED) === index
